import { Input } from "design-react-kit";
import moment from "moment";
import { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { Link, useLocation } from "react-router-dom";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
import Select from "../../Components/Select";
import { PROVINCE } from "../../Components/listaProvince";
import { NAZIONI } from "../../Components/listaNazioni";
import { TokenContext } from "../../Components/TokenContext";

function EditUser(props) {
  useEffect(() => {
    const handlePopState = () => {
      window.location.reload();
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenState, toggleModalState] = useState(false);

  const [error, setError] = useState("");

  const [validation, setValidation] = useState(false);
  const [validationBirth, setValidationBirth] = useState(true);
  const [user, setUser] = useState({});

  const [isDisabled, setIsDisabled] = useState(true);

  const [listaProvince] = useState(PROVINCE);
  const [listaNazioni] = useState(NAZIONI);

  // const [content, setContent] = useState('');

  let query = useQuery();

  useEffect(() => {
    if (query.get("id") != null) {
      if (query.get("idTransazione") != null) {
        var data = JSON.stringify({
          idTransazione: query.get("idTransazione"),
          EsitoWisp: query.get("EsitoWisp"),
          FaultWisp: query.get("FaultWisp"),
          IdentificativoPagamenti: query.get("IdentificativoPagamenti"),
          IUV: query.get("IUV"),
        });

        Repo.postUpdatePosizioneDebitoria(apiToken, data)
          .then((response) => {
            alert(data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      window.location.href = props.subfolder + "/lista_utenti";
    }
  }, []);

  useEffect(() => {
    setUser(props.user);
  }, [props.user]);

  const userEditValidation = () => {
    setValidation(true);
    let passedValidation = true;
    Object.entries(user).map(([key, value]) => {
      if (key == "birthDate") {
        if (value == "" || value == null) {
          setValidationBirth(false);
          passedValidation = false;
        } else if (user.birthDate.isValid && !user.birthDate.isValid()) {
          setValidationBirth(false);
          passedValidation = false;
        }
      }
    });
    if (passedValidation) {
      user.birthdate = moment(user.birthDate, "DD/MM/YYYY")
        .format("YYYY-MM-DD")
        .toString();

      setUser({ ...user });

      toggleModal(!isOpen);
    }
  };

  const editUserAPI = () => {
    Repo.postUpdateUser(apiToken, JSON.stringify(user))
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const userState = (userId) => {
    Repo.postUpdateUserStatus(apiToken, userId)
      .then((response) => {
        if (response.status == 204) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const CambiaStatoUtenteButtonClick = () => {
    // Chiamata al metodo per cambiare lo stato dell'utente qui...
    // Dopo aver eseguito l'azione, chiudi la modale
    toggleModal();
  };

  const CambiaStatoUtente = () => {
    userState(user.id);
  };

  //tinyEditor
  const [editorContent, setEditorContent] = useState("");

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  //tinyEditor fine

  return (
    <>
      {/*Inizio modifica dati cittadino*/}
      <div className="row mt-2">
        <div className="col-lg-4">
          <Input
            id="firstName"
            disabled={isDisabled}
            label="Nome*"
            type="text"
            name="firstName"
            value={user && user.firstName ? user.firstName : ""}
            onChange={(e) => setUser({ ...user, firstName: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="last_name"
            disabled={isDisabled}
            label="Cognome*"
            type="text"
            name="last_name"
            value={user && user.lastName ? user.lastName : ""}
            onChange={(e) => setUser({ ...user, lastName: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="fiscal_code"
            disabled={true}
            label="Codice Fiscale*"
            type="text"
            name="fiscal_code"
            value={user && user.fiscalCode ? user.fiscalCode : ""}
            onChange={(e) => setUser({ ...user, fiscalCode: e.target.value })}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-2">
          <Input
            id="birthdate"
            disabled={isDisabled}
            label="Data di Nascita*"
            type="date"
            name="birthdate"
            placeholder="gg/mm/aaaa"
            value={
              user && user.birthDate != null
                ? moment(user.birthDate, "DD/MM/YYYY")
                    .format("YYYY-MM-DD")
                    .toString()
                : ""
            }
            onChange={(e) =>
              setUser({
                ...user,
                birthDate: moment(e.target.value),
              })
            }
            {...(validation &&
              !validationBirth && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-2">
          <Input
            id="dataDecesso"
            disabled={isDisabled}
            label="Data Decesso"
            type="date"
            name="dataDecesso"
            value={
              user && user.dataDecesso != null
                ? moment(user.dataDecesso, "DD/MM/YYYY")
                    .format("YYYY-MM-DD")
                    .toString()
                : " "
            }
            onChange={(e) =>
              setUser({
                ...user,
                dataDecesso: moment(e.target.value),
              })
            }
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="email"
            disabled={isDisabled}
            label="Email"
            type="text"
            name="email"
            value={user && user.email ? user.email : ""}
            onChange={(e) => setUser({ ...user, email: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="emailPec"
            disabled={isDisabled}
            label="Pec"
            type="text"
            name="emailPec"
            value={user && user.emailPec ? user.emailPec : ""}
            onChange={(e) => setUser({ ...user, emailPec: e.target.value })}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-2">
          <Input
            id="phone_number"
            disabled={isDisabled}
            label="Telefono"
            type="text"
            name="phone_number"
            value={user && user.phoneNumber ? user.phoneNumber : ""}
            onChange={(e) => setUser({ ...user, phoneNumber: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="address"
            disabled={isDisabled}
            label="Indirizzo residenza*"
            type="text"
            name="address"
            value={user && user.address ? user.address : ""}
            onChange={(e) => setUser({ ...user, address: e.target.value })}
            {...(validation &&
              !user.address && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-3">
          <Input
            id="number"
            disabled={isDisabled}
            label="N. Civico*"
            type="text"
            name="number"
            value={user && user.addressNumber ? user.addressNumber : ""}
            onChange={(e) =>
              setUser({ ...user, addressNumber: e.target.value })
            }
            {...(validation &&
              !user.addressNumber && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-3">
          <Input
            id="cap"
            disabled={isDisabled}
            label="CAP*"
            type="text"
            name="cap"
            value={user && user.cap ? user.cap : ""}
            onChange={(e) => setUser({ ...user, cap: e.target.value })}
            {...(validation &&
              !user.cap && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-4">
          <Input
            id="city"
            disabled={isDisabled}
            label="Città*"
            type="text"
            name="city"
            value={user && user.city ? user.city : ""}
            onChange={(e) => setUser({ ...user, city: e.target.value })}
            {...(validation &&
              !user.city && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-4">
          <div className="bootstrap-select-wrapper col-12">
            <Select
              aria-label="Scegli una provincia*"
              clearText="Annulla"
              isDisabled={isDisabled}
              defaultMenuIsOpen={false}
              icon={false}
              autoComplete="off"
              id="country"
              onChange={(e) => {
                setUser({ ...user, country: e.value });
              }}
              options={listaProvince}
              isSearchable
              placeholder={
                user && user.country ? user.country : "Scegli una provincia*"
              }
            />
          </div>
          {validation && !user.country ? (
            <small id="errorSelect" className="form-text  text-danger">
              Il campo non può essere vuoto!
            </small>
          ) : (
            <></>
          )}
        </div>
        <div className="col-lg-4">
          <Select
            id="nation"
            options={NAZIONI}
            value={user && user.nation ? user.nation : null}
            onChange={(e) => setUser({ ...user, nation: e.value })}
            isDisabled={isDisabled}
            isRequired={true}
            validation={true}
            columnClass="col-12" // Classe CSS delle colonne di Bootstrap
            autoComplete="off" // Disabilita l'autocompletamento
            placeholder={
              user && user.nation ? user.nation : "Scegli una nazione*"
            }
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="mt-n3 col-2">
          <div className="small text-muted">
            <strong>Sesso*</strong>
          </div>
          <div className="row">
            <div className="col-4">
              <div className="cmp-card-radio">
                {" "}
                <div className="radio-body">
                  <input
                    disabled={isDisabled}
                    id="sessoM"
                    name="sesso"
                    value="M"
                    type="radio"
                    className="mr-2"
                    checked={user.gender === "M"}
                    style={{ cursor: "pointer" }}
                    onChange={(e) =>
                      setUser({ ...user, gender: e.target.value })
                    }
                  />
                  <label
                    htmlFor="sessoM"
                    className="active"
                    style={{ cursor: "pointer" }}
                  >
                    <strong>M</strong>
                  </label>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="radio-body">
                <input
                  disabled={isDisabled}
                  type="radio"
                  id="sessoF"
                  name="sesso"
                  value="F"
                  className="mr-2"
                  checked={user.gender === "F"}
                  style={{ cursor: "pointer" }}
                  onChange={(e) => setUser({ ...user, gender: e.target.value })}
                />
                <label
                  htmlFor="sessoF"
                  className="active"
                  style={{ cursor: "pointer" }}
                >
                  <strong>F</strong>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <Input
            id="homeAddress"
            disabled={isDisabled}
            label="Domicilio"
            type="text"
            name="homeAddress"
            value={user && user.homeAddress ? user.homeAddress : ""}
            onChange={(e) => setUser({ ...user, homeAddress: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="ruoloFamiliare"
            disabled={isDisabled}
            label="Ruolo Familiare"
            type="text"
            name="ruoloFamiliare"
            value={user && user.ruoloFamiliare ? user.ruoloFamiliare : ""}
            onChange={(e) =>
              setUser({ ...user, ruoloFamiliare: e.target.value })
            }
          />
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-lg-12">
          {user?.dataDecorrenza ? (
            <span>
              <strong>Data di decorrenza del cambio di residenza:</strong>{" "}
              {user.dataDecorrenza} (fonte ANPR)
            </span>
          ) : (
            <span className="text-muted">ANPR non verificato</span>
          )}
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-6">
          <p></p>
        </div>
        <div className="col-6 text-right">
          {isDisabled ? (
            <>
              <button
                type="button"
                className="btn btn-outline-primary ml-2"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setIsDisabled(!isDisabled)}
                title="Modifica"
              >
                Modifica
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-outline-secondary ml-2"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setIsDisabled(!isDisabled)}
                title="Indietro"
              >
                Indietro
              </button>

              <button
                type="button"
                className="btn btn-outline-primary ml-2"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => userEditValidation()}
                title="Conferma"
              >
                Conferma
              </button>
            </>
          )}

          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={() => toggleModalState(true)}
          >
            {user &&
            (user.state === "LOADED" ||
              user.state === "REFUSED" ||
              user.state === "SUSPEND")
              ? "ABILITA"
              : "SOSPENDI"}
          </button>
        </div>
      </div>
      {/*Fine modifica dati cittadino*/}

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header={
          user && "Modifica utente: " + user.firstName + " " + user.lastName
        }
        body={
          user &&
          "Confermi di voler modificare i dati di " +
            user.firstName +
            " " +
            user.lastName +
            "?"
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => editUserAPI()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalState}
        isOpen={isOpenState}
        header="Cambia Stato"
        body={
          user &&
          `Confermi di voler modificare lo stato in ${
            user.state === "VALIDATED" ? "SOSPESO" : "ATTIVO"
          } di ${user.firstName} ${user.lastName}?`
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => CambiaStatoUtente()}
      ></ModalComponent>
    </>
  );
}

export default EditUser;
